import {useQuery , useMutation} from "react-query";
import {getAxios, postAxios} from "../../axios/generic-api-calls";
import {CarModel, SeasonModel, SeasonsPaginatedModel, SignInUserToASeasonModel} from "./seasonTypes";

export function useFetchSeasons(key: string = 'events') {
    return useQuery<SeasonsPaginatedModel>(key, () => getAxios('/event'));
}

export function useFetchSeasonByIdOrSlug(idOrSlug: string, key: string = 'event') {
    return useQuery<SeasonModel>(key, () => getAxios(`event/${idOrSlug}`));
}

export function useFetchSeason( key: string = 'eventBanner') {
    return useQuery<SeasonModel>(key, () => getAxios(`/event`));
}

export function useFetchCarsWithSeason(seasonID:number, key: string = 'cars') {
    return useQuery<CarModel[]>(key, () => getAxios(`event/${seasonID}/cars`));
}
export function useSignInUserToASeason(seasonID: number) {
    return useMutation((data: SignInUserToASeasonModel) => postAxios(`event/${seasonID}/sign-in`, data),       {
        onSuccess: () => {
       console.log('udalo sie')
        },
        onError: () => {
            console.log('dupa')
        },
    });
}




